<template lang="pug">
.container
  .row
    .col-xs-12
      h1.main_title {{$route.name}} Upgrade History
    .col-md-12.clearfix.col-centered.col-sm-12.col-xs-12
      .col-md-4.filter.clearfix
        form.form-horizontal
          .form-group
            label.control-label.h4
              | Filter
            input.form-control.input-sm(v-model='snFilter' placeholder="Serial Number")
      pagination(
        v-bind:count-of-page.sync="countOfPage"
        v-bind:curr-page.sync="currPage"
        v-bind:count-of-pagination="countOfPagination"
        v-bind:curr-pagination-sec.sync='currPaginationSec'
        v-bind:target-ary.sync='filteredLog'
        v-if="filteredLog.length > 10")
      table.table.table-hover.table-bordered
        tr
          th Serial Number
          th Date
          th Version
          th(v-if="user.role === 'admin'") Action
        tr(v-for="h in filteredLog | orderBy 'startedAt' -1 | limitBy countOfPage pageStart")
          td {{h.sn}}
          td {{h.startedAt | timeFormat}}
          td {{h.version}}
          td(v-if="user.role === 'admin'")
            button.btn.btn-xs.btn-danger(@click="deleteUpgHis(h['.key'])") Delete
</template>

<script>
import pagination from '../common/Pagination.vue'
import { getSmartCtrlHistory, getSwitchHistory } from '../../index.js'

export default {
  components: {
    pagination
  },
  data () {
    return {
      snFilter: '',
      countOfPage: 10,
      currPage: 1,
      countOfPagination: 5,
      currPaginationSec: 1
    }
  },
  vuex: {
    getters: {
      user: state => state.user
    }
  },
  computed: {
    filteredLog () {
      return this[this.$route.name].filter(f => f.sn.indexOf(this.snFilter) !== -1)
    },
    totalLength () {
      return this[this.$route.name].length
    },
    pageStart () {
      return (this.currPage - 1) * this.countOfPage
    }
  },
  methods: {
    deleteUpgHis (key) {
      if (key == null) { return }
      if (this.user.role === 'admin') {
        getSmartCtrlHistory().child(key).remove()
      }
    }
  },
  firebase () {
    return {
      'smart-controller': getSmartCtrlHistory(),
      switch: getSwitchHistory()
    }
  },
  ready () {
    console.log('filterd Log is:', this.$route.name)
    // this.$firebaseRefs.history.push({
    //   fwVersion: 'V1.5i_h',
    //   startedAt: Date.now(),
    //   sn: '00000000d64a88ad'
    // })
  },
  watch: {
    snFilter: {
      handler: function (nv) {
        this.currPage = 1
        this.currPaginationSec = 1
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.filter{
  margin-bottom: 15px;
}
.table{
  & th, & td {
    text-align: center;
  }
  & th {
    width: 33%;
    background-color: #f8f8f8;
  }
}
h1{
  text-transform: capitalize;
}
.total{
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// History.vue?0cd66f82